export default {
    props: {
      items: Array,
      value: String | Object | Number,
     
    },
    watch: {
      value: {
        immediate: true,
        handler: function(newValue) {
          this.dataValue = newValue
        }
      }
    },
    computed: {
      dataValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
  }